import React, { useContext } from 'react';
import classNames from 'classnames';
import ButtonSecondaryEllipse from '../ButtonSecondaryEllipse';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import { GradientContext } from '../../containers/BasePage';
import { motion } from 'framer-motion';
import s from './SlideShowNav.module.scss';

const SlideShowNav = ({
  indicators = [],
  indicatorIndex,
  setIndicatorIndex,
  color,
  isVisible,
  hideDesktop,
  hideIpad,
  emblaApi,
  ...props
}) => {
  const [ref] = useIntersectionObserver(0, undefined, true);
  const gradient = useContext(GradientContext);

  const scrollToIndex = (i) => {
    if (!emblaApi) return;
    emblaApi.scrollTo(i);
    setIndicatorIndex(i);
  };

  const handleNext = () => {
    const next = Math.min(indicatorIndex + 1, indicators.length - 1);
    scrollToIndex(next);
  };

  const handlePrev = () => {
    const prev = Math.max(indicatorIndex - 1, 0);
    scrollToIndex(prev);
  };

  const rootClasses = classNames(s.Root, s[gradient], {
    [s.Visible]: isVisible,
    [s.HideDesktop]: hideDesktop,
    [s.HideIpad]: hideIpad,
    [s.White]: color !== 'black',
  });

  const progress =
    indicators.length > 1
      ? ((indicatorIndex + 1) / indicators.length) * 100
      : 0;

  return (
    <div className={rootClasses} ref={ref} {...props}>
      <div className={s.SlideShowIndicatorContainer}>
        <div className={s.SlideShowIndicatorBase}>
          <motion.div
            className={s.Highlighted}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          />
        </div>
      </div>

      <div className={s.SlideShowButtons}>
        <ButtonSecondaryEllipse
          icon={
            color !== 'black'
              ? 'icon-dropdown-arrow-left-black'
              : 'icon-dropdown-arrow-left-white'
          }
          modifiers={[
            `${color !== 'black' && 'SlideShowNavWhite'}`,
            'SlideShowNav',
          ]}
          onClick={handlePrev}
          disabled={indicatorIndex === 0}
        />

        <ButtonSecondaryEllipse
          icon={
            color !== 'black'
              ? 'icon-dropdown-arrow-right-black'
              : 'icon-dropdown-arrow-right-white'
          }
          modifiers={[
            `${color !== 'black' && 'SlideShowNavWhite'}`,
            'SlideShowNav',
          ]}
          onClick={handleNext}
          disabled={indicatorIndex === indicators.length - 1}
        />
      </div>
    </div>
  );
};

export default SlideShowNav;
